














import Vue from 'vue'

export default Vue.extend({
  name: 'AppNavbarButton',
  props: {
    icon: {
      type: String,
      default: ''
    },
    dir: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    solid: {
      type: [Boolean, String],
      default: false
    },
    size: {
      type: [Number, String],
      default: 24
    }
  }
})
